/* src/app/nav/nav.component.css */
.sidenav-container {
  height: 100%;
}
mat-sidenav-content {
  scroll-behavior: smooth;
}
.sidenav {
  width: 200px;
  background-color: var(--primary-color);
}
.sidenav .mat-mdc-list-item {
  color: #FFFFFF;
}
.white {
  color: #FFFFFF;
}
.sidekick-logo {
  height: 32px;
  width: auto;
  max-width: 180px;
}
.mr10 {
  margin-right: 10px;
}
.sidenav .mat-toolbar {
  background: inherit;
}
.mat-toolbar.mat-primary {
  position: sticky;
  top: 0;
  z-index: 10;
}
.sidebar-fill {
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: left bottom;
  background-size: 199px 423px;
}
.username {
  font-size: 14px;
  color: #FFFFFF;
  opacity: 0.5;
}
.version {
  display: flex;
  flex: 0 0 auto;
  justify-content: center;
  color: #FFFFFF;
  font-size: 14px;
  opacity: 0.5;
  position: absolute;
  bottom: 0;
  margin-bottom: 20px;
  width: 100%;
}
.sidebarImage {
  margin-top: 4px;
  display: flex;
}
.menu-button-container {
  display: flex;
  flex: 1 1 auto;
  align-items: flex-start;
  flex-direction: column;
  margin-left: 10px;
}
.menu-button {
  background-color: var(--green-accent) !important;
  min-width: 150px;
  height: 32px;
}
.menu-button.menu-button-disabled {
  background-color: #9e9e9e !important;
  opacity: 0.6;
  cursor: default;
}
.user_nav {
  display: flex;
  flex: 1 1 auto;
  justify-content: flex-end;
  align-items: center;
}
.user_nav_header {
  display: flex;
  flex-direction: column;
  padding: 5px 16px 10px 16px;
  color: var(--primary-color);
}
.user_nav_header div {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
}
.accout_header {
  gap: 5px;
  font-weight: bold;
}
.nav_menu_item_text_color {
  color: var(--primary-color);
}
.corpBox {
  margin-top: 20px;
  padding-left: 16px;
  padding-right: 16px;
}
.account_button {
  padding: 8px 8px;
  background-color: var(--green-accent) !important;
}
.account_button_icon {
  height: 32px;
  width: 32px;
  font-size: 32px;
}
.accounts {
  display: flex;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;
  padding-top: 20px;
  position: relative;
  height: inherit;
  margin-top: 20px;
  border-top: 1px solid var(--secondary-color);
  color: #FFFFFF;
  font-size: 14px;
}
.inner_menu_button_container {
  display: flex;
  justify-content: space-between;
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0;
}
.menu_button_center {
  margin: auto 5px;
  color: #FFFFFF;
  font-weight: bold;
}
.menu_button_right {
  display: flex;
  align-items: center;
  width: 24px;
  color: #FFFFFF;
}
.menu_button_left {
  flex: 0 1 auto;
  width: 24px;
}
@media (max-width: 600px) {
  .menu-button-container {
    align-items: stretch;
  }
}
.nav-item-disabled {
  opacity: 0.45;
  pointer-events: none;
  cursor: default;
}
/*# sourceMappingURL=nav.component.css.map */
